export default String.raw`
{% if settings.compareProducts == 'yes' -%}
    {% assign productsInComparisonCount = customer.ComparisonToolItems | Size -%}
    {% assign maxProductsInComparison = config.Products.ProductComparer -%}
    {% assign remainingProductsCount = maxProductsInComparison | Minus: productsInComparisonCount -%}
    {% assign comparer = comparison-tool -%}
    {% assign products = comparer.Products -%}
    {% assign attributes = comparer.Attributes -%}

    <dialog class="dialog comparison__dialog">
        <div class="dialog__header">
            <div class="dialog__header-wrapper">
                <svg height="24" width="24">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                </svg>
                <div class="dialog__header-info">
                    <h2 class="dialog__header-title">{{translations.AddedToCompare}} ({{productsInComparisonCount}}/{{maxProductsInComparison}})</h2>
                    <p class="dialog__header-description">{{translations.ComparisonRemaining | Format: remainingProductsCount}}</p>
                </div>
            </div>
            <div class="comparison__items">
                {% for i in (1..maxProductsInComparison) -%}
                <svg class="{% if productsInComparisonCount < i -%} empty {% endif -%}" height="20" width="20">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#box-{{settings.iconStyle}}"></use>
                </svg>
                {% endfor -%}
            </div>
            <form method="dialog">
                <button class="dialog__close close-js" aria-label="{{ translations.Close }}">
                    <svg aria-hidden="true" height="24" width="24">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                    </svg>
                </button>
            </form>
        </div>
        <div class="dialog__content">
            <ul tabindex="-1" class="comparison__list">
                {% for product in products -%}
                <li class="comparison__list-item">
                    <div class="product__image-wrapper">
                        {% if product.Image.Id > 0 and product.Image.Link -%}
                            <img class="product__image" width="80" height="80" src="css/img/alo.gif" data-src="img/small/{{product.Image.Id}}/{{product.Image.Link}}" alt="{{product.NameNoHtml}}" loading="eager" fetchpriority="high">
                        {% elsif product.Image.ExternalUrl -%}
                            <img class="product__image" width="80" height="80" src="css/img/alo.gif" data-src="{{product.Image.ExternalUrl}}" alt="{{product.NameNoHtml}}" loading="eager" fetchpriority="high">
                        {% else -%}
                            <img class="product__image" width="80" height="80" src="css/img/alo.gif" data-src="css/img/img-placeholder.jpg" alt="{{translations.DefaultImage}}" loading="eager" fetchpriority="high">
                        {% endif -%}
                    </div>
                    <div class="comparison__list-item-info">
                        <p>{{product.NameNoHtml}}</p>
                        <div class="comparison__list-item-attributes">
                            {% if attributes -%}
                                {% assign displayedAttributes = 0 -%}
                                {% for attributeName in attributes -%}
                                    {% if displayedAttributes >= 2 -%}
                                        {% break -%}
                                    {% endif -%}

                                    {% assign hideAttr = false -%}
                                    {% if attribute contains '360photo' -%}
                                        {% assign hideAttr = true -%}
                                    {% endif -%}

                                    {% if hideAttr == false -%}
                                    {% assign attributeValues = product.Attributes[attributeName] -%}
                                        {% if attributeValues.size > 0 -%}
                                        <span class="attribute">
                                            {{attributeName}}:
                                            <b>
                                            {% for attributeValue in attributeValues -%}
                                                {% if attributeValue != attributeValues.last-%}
                                                    {{attributeValue}},
                                                {% else -%}
                                                    {{attributeValue}}
                                                {% endif -%}
                                            {% endfor -%}
                                            </b>
                                        </span>
                                        {% assign displayedAttributes = displayedAttributes | Plus: 1 -%}
                                        {% endif -%}
                                    {% endif -%}
                                {% endfor -%}
                            {% endif -%}
                        </div>
                    </div>
                </li>
                {% endfor -%}
            </ul>
        </div>
        <div class="dialog__actions">
            <form method="dialog">
                <button class="pure-button close-js" style="gap: 10px;">
                    <svg height="14" width="9">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-left-{{settings.iconStyle}}"></use>
                    </svg>
                    <span>{{translations.BackToShopping}}</span>
                </button>
            </form>
            <a class="primary-action-button" href="{{ page.BaseHref }}{{config.DefinedPages.ProductComparisonTool.Url}}">
                <span>{{translations.GoToComparer}}</span>
                <svg height="24" width="24">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#balance-scale-left-{{settings.iconStyle}}"></use>
                </svg>
            </a>
        </div>
    </dialog>
{% endif -%}

`